import { render, staticRenderFns } from "./PersonalParent.vue?vue&type=template&id=53cfa992"
import script from "./PersonalParent.vue?vue&type=script&lang=js"
export * from "./PersonalParent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports